import { Injectable } from '@angular/core';
import { GlobalEmailTypes } from '../constants-types/Enums';
import { InitDataService } from '../system-services/InitData/InitData.service';
import { TranslationService } from '../translations';

/*
Should this exist? It has no state and should not be a data service. Right
now it is the home of a single function. The idea was to remove stuff from
the SendAssessmentEmailDataService but this might not be the best way to do
so. Definitely consider killing this.
*/
@Injectable({ providedIn: 'root' })
export class SendAssessmentEmailDataService {
    constructor(
        private TR: TranslationService,
        private initData: InitDataService
    ) {}

    // This is not built in the best way. It would be nice if we sent 1 call - should revisit when we do main site
    // Also it would be nice to encapsulate this entirely in translation service
    getSubjectsAndMessages(
        languageLocale = this.TR.currentLocale
    ): Promise<any> {
        return Promise.all([
            this.TR.getEmailSubjectMessageOverrides(
                [
                    'email.send.assessment.survey.pi.subject.new',
                    'GlobalEmailPiRemoteSurveyMessage'
                ],
                languageLocale,
                this.initData.user.companyId,
                GlobalEmailTypes.BehavioralAssessmentEmail
            ),
            this.TR.getEmailSubjectMessageOverrides(
                [
                    'email.send.assessment.cognitive.subject',
                    'GlobalEmailCognitiveRemoteAssessmentMessage'
                ],
                languageLocale,
                this.initData.user.companyId,
                GlobalEmailTypes.CognitiveAssessmentEmail
            ),
            this.TR.getEmailSubjectMessageOverrides(
                [
                    'email.send.assessment.survey.pro.subject',
                    'GlobalEmailProRemoteSurveyMessage'
                ],
                languageLocale,
                this.initData.user.companyId,
                GlobalEmailTypes.JobAssessmentEmail
            )
        ]);
    }
}
